import React, { useEffect, useState } from 'react'
import { UiComponents, defaultLogo } from "@simulanisindia/ui";
import { FilterIcon } from '../Assets/Icons';
import { RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB } from '../Constant/constant';

const FilterManagement = ({ openFilter = null, selectedCheckboxes = [] }) => {
    const { SearchBar, SimFilter } = UiComponents;

    const [list, setList] = useState([]);
    const [showfilter, setShowFilter] = useState(false);
    // const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

    // const [filterCategoryOption, setFilterCategoryOption] = useState({
    //     [RESOURCE_APPLICATION_TAB]: [],
    //     [RESOURCE_MODULE_TAB]: [],
    //     [RESOURCE_ENVIRONMENT_TAB]: [],
    //     [RESOURCE_SKILL_STREAM_TAB]: [],
    //     [RESOURCE_SKILL_SCHOOL_TAB]: [],
    // });


    // const body = document.body;
    // const openFilter = () => {
    //     setShowFilter(!showfilter);
    //     if (!showfilter) {
    //         body.classList.add("filter-active");
    //     } else {
    //         body.classList.remove("filter-active");
    //     }
    // };

    return (
        <>
            <div className="filterbtn" onClick={openFilter}>
                <div className="btninadjust">
                    <FilterIcon />
                    {selectedCheckboxes.length > 0 && <span className="filter-active-span"></span>}
                </div>
            </div>
        </>
    )
}

export default FilterManagement
